module.exports = __webpack_public_path__ + "static/media/seunghyun-hong-new.cc195dc0.png";